import studentRequest from '../../utils/studentRequest'

export const setOptedStatus = data => {
  return {
    type: 'SET_OPTED_STATUS',
    data,
  }
}

export const studentOptedStatus = () => async (dispatch, getState) => {
  const state = getState()
  const studentId = state?.auth?.studentId
  try {
    const res = await studentRequest.get(`/students/${studentId}/optedStatus`)

    // return res?.data?.data
    dispatch(setOptedStatus(res?.data?.data))
  } catch (error) {
    console.log('Error in Getting Optout status', error)
  }
}

export const updateOptedStatus = payLoad => async (dispatch, getState) => {
  const state = getState()
  const studentId = state?.auth?.studentId
  try {
    const res = await studentRequest.put(
      `/students/${studentId}/optedStatus`,
      payLoad
    )
    return res?.data?.data
  } catch (error) {
    console.log('Error in Student Optout Status', error)
  }
}

export const updateOptedWitdrawStatus =
  payLoad => async (dispatch, getState) => {
    const state = getState()
    const studentId = state?.auth?.studentId
    try {
      const res = await studentRequest.put(
        `/students/${studentId}/optedStatus/withdraw`,
        payLoad
      )
      return res?.data?.data
    } catch (error) {
      console.log('Error in Student Optout Withdraw Status', error)
    }
  }

export const rejectStudentStatus = payLoad => async (dispatch, getState) => {
  const state = getState()
  const studentId = state?.auth?.studentId
  try {
    const res = await studentRequest.put(
      `students/${studentId}/optedStatus/rejectedOneTimeUpdate
`,
      payLoad
    )
    return res?.data?.data
  } catch (error) {
    console.log('Error in Student Optout Withdraw Status', error)
  }
}
